// ©2024 Austin App House. All rights reserved.
import React from 'react';
import '../../../sass/custom_styles/tableLoader.scss';

const TableLoader = ({ visible }) => (
    <div className={`table-loader-container show`}>
        <div className="table-loader" />
    </div>
);

export default TableLoader;